module.exports = __webpack_public_path__ + "static/media/bird-picking-stick.83ac3692.gif";